export type ServerMessage =
  | { type: "audio"; data: string; text: string; input: string; actor: string; kind?: "reply" | "cron" }
  | { type: "transcript"; text: string; input?: string; actor: string; kind: "error" }
  | { type: "info"; message: string }
  | { type: "error"; message: string }
  | { type: "close"; message: string }
  | { type: "hello"; message: string };

export function openSocket(
  onMessage: (m: ServerMessage) => void,
  onState: (s: "open" | "closed" | "error") => void,
): WebSocket {
  const protocol = location.protocol === "https:" ? "wss:" : "ws:";
  const ws = new WebSocket(`${protocol}//${location.host}`);
  ws.binaryType = "arraybuffer";
  ws.addEventListener("open", () => onState("open"));
  ws.addEventListener("close", () => onState("closed"));
  ws.addEventListener("error", () => onState("error"));
  ws.addEventListener("message", (ev) => {
    try {
      onMessage(JSON.parse(ev.data));
    } catch (err) {
      console.error("bad ws message", err);
    }
  });
  return ws;
}
